import React from 'react';
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import customersStorageService from 'src/app/customers/services/customers-storage-service';
import { navRoutesConfig } from 'src/shared/data/navRoutesConfig';
import { GNPViews } from 'src/routes/routesConfig';
import GNPOrgManagement from './gnp-org-management/GNPOrgManagement';

/**
 * Names an organisation in the url, so the page stays shareable and bookmarkable. Falls back
 * to the current one, which is what an unnamed organisation can only have meant.
 */
const OrganisationRedirect = () => {
    const [searchParams] = useSearchParams();
    const customerId = searchParams.get('customerId') ?? customersStorageService.getCurrentCustomerId() ?? '';

    return <Navigate to={navRoutesConfig[GNPViews.ORG_MANAGEMENT]({ customerId })} replace />;
};

/**
 * The Nature Performance admin area. Everything here concerns one organisation, so the area
 * root resolves to that organisation rather than a list — choosing between organisations is
 * the sidebar's organisation selector, not a page of its own.
 */
const NaturePerformance = () => (
    <Routes>
        <Route path='nature-performance' element={<GNPOrgManagement />} />
        <Route path='/*' element={<OrganisationRedirect />} />
    </Routes>
);

export default NaturePerformance;
